import { defineComponent, h } from "vue";

const svgProps = {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};

const rect = (attrs: Record<string, number>) =>
  h("rect", { ...attrs, rx: 1, fill: "currentColor" });

export default defineComponent({
  name: "CaptionBelowIcon",
  render: () =>
    h("svg", svgProps, [
      rect({ x: 4, y: 4, width: 3, height: 8 }),
      rect({ x: 8.5, y: 4, width: 3, height: 8 }),
      rect({ x: 13, y: 4, width: 3, height: 8 }),
      rect({ x: 4, y: 14, width: 12, height: 2 }),
    ]),
});
